import api from './client'; // Import the shared client

const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone; // ✅ add at top


export const getUserGoals = async () => {
  const res = await api.get(`/users/me/goals`);
  return res.data;
};

export function getUserGoal(goalId) {
  if (!goalId) {
    console.error('getUserGoal called with invalid goalId:', goalId);
    return;
  }
  return api.get(`/users/me/goals/${goalId}`);
}

export const getActiveGoals = () => {
  return api.get("/users/goals/active", {
    params: { timeZone: userTimeZone }, // ✅ does this exist here?
  });
};

// userGoalApi.js
const DIFFICULTY_MAP = {
  EASY: 1,
  MEDIUM: 2,
  HARD: 3,
};

export const createUserGoal = async (
  title,
  difficulty,
  dailyHabit = false,
  reminderEnabled = false,
  reminderTime = null,
  reminderDays = []
) => {
  const response = await api.post('/users/goals', {
    goalTitle: title,
    difficulty: typeof difficulty === 'string' ? DIFFICULTY_MAP[difficulty] : difficulty,
    dailyHabit,
    reminderEnabled,
    reminderTime: reminderEnabled ? reminderTime : null,
    reminderDays: reminderEnabled ? reminderDays : [],
  });

  return response.data;
};

export const updateGoalReminder = async (goalId, reminderData) => {
  const response = await api.patch(`/users/goals/${goalId}/reminder`, reminderData);
  return response.data;
};

export function renameUserGoal(goalId, newTitle) {
  return api.put(`/users/goals/${goalId}`, null, { params: { newTitle } });
}

export function deleteUserGoal(goalId) {
  return api.delete(`/users/goals/${goalId}`);
}

export function reorderUserGoals(positions) {
  return api.put('/users/goals/reorder', positions);
}

export function completeGoal(goalId) {
  return api.put(`/users/goals/${goalId}/complete`);
}

export function updateGoalDifficulty(goalId, difficulty) {
  return api.patch(`/users/goals/${goalId}/difficulty`, { difficulty });
}

export function toggleArchiveGoal(goalId) {
  return api.put(`/users/goals/${goalId}/archived/toggle`);
}

export function getArchiveGoals() {
   return api.get('/users/goals/archived', {
    params: { timeZone: userTimeZone }
  });
}

export function getAchievements() {
  return api.get('/users/goals/achievements');
}

export function getPublicAchievements(userId) {
  return api.get(`/users/${userId}/achievements/public`);
}
export function toggleAchievementGoal(goalId) {
  return api.put(`/users/goals/${goalId}/achievement/toggle`);
}


export const updateGoalCategory = (goalId, category, useCase) => {
  return api.patch(`/users/goals/${goalId}/category`, { category, useCase });
};

// api/userGoalApi.js

export const updateGoalPrivacy = async (goalId, privacyData) => {
  // Check if your backend base URL in 'api' (axios instance) 
  // already includes '/api'. If not, you might need `/api/users/goals...`
  const response = await api.patch(`/users/goals/${goalId}/privacy`, privacyData);
  return response.data; // Return the data so the hook can use the updated DTO
};

